import type { ReactNode } from "react";
import SignalsTooltipTimeFrame from "../SignalsTooltipTimeFrame/SignalsTooltipTimeFrame";
import { StyledTooltipBody, StyledTooltipFooter, StyledTooltipHeader, StyledTooltipTitle } from "./styles";

type Props = {
    children: ReactNode;
    title: NonNullable<ReactNode>;
    footer: NonNullable<ReactNode>;
    withTimeFrame?: boolean;
};

const SignalsTooltipContent = ({ children, title, footer, withTimeFrame = false }: Props) => {
    return (
        <>
            <StyledTooltipHeader>
                <StyledTooltipTitle>{title}</StyledTooltipTitle>

                {withTimeFrame ? <SignalsTooltipTimeFrame text={{ key: "si.signals.table-columns.tooltip.time-frame" }} /> : null}
            </StyledTooltipHeader>

            <StyledTooltipBody>{children}</StyledTooltipBody>

            <StyledTooltipFooter>{footer}</StyledTooltipFooter>
        </>
    );
};

export default SignalsTooltipContent;
